import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { api } from "../lib/api";
import RouteCard from "../components/RouteCard";
import Pagination from "../components/Pagination";
import { Heart } from "@phosphor-icons/react";

export default function Favorites() {
  const { user, loading } = useAuth();
  const [routes, setRoutes] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [page, setPage] = useState(0);
  const [pageSize] = useState(20);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    if (!user) return;
    api
      .get("/me/favorites", { params: { page, page_size: pageSize } })
      .then(({ data }) => {
        const payload = Array.isArray(data)
          ? { routes: data }
          : data.items || data;
        setRoutes(payload.routes || []);
        setTotal(data.total || 0);
        setLoaded(true);
      })
      .catch(() => setLoaded(true));
  }, [user, page, pageSize]);

  if (loading)
    return (
      <div className="min-h-screen flex items-center justify-center">
        Loading…
      </div>
    );

  if (!user) {
    return (
      <div className="min-h-screen bg-[#F9F6F0] flex items-center justify-center">
        <div className="text-center max-w-md px-6">
          <Heart
            size={40}
            weight="duotone"
            className="text-[#C86B4E] mx-auto"
          />
          <h1 className="font-display font-black text-3xl mt-4">
            Sign in to save routes
          </h1>
          <p className="text-[#5C665F] mt-2">
            Keep a personal list of dream routes for your next adventure.
          </p>
          <Link
            to="/"
            className="inline-block mt-6 bg-[#2C5545] text-white rounded-full px-6 py-3 font-bold"
          >
            Back home
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#F9F6F0]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16 lg:py-24">
        <div className="text-xs uppercase tracking-[0.3em] font-bold text-[#C86B4E]">
          Your atlas
        </div>
        <h1 className="font-display font-black text-4xl sm:text-5xl mt-3">
          Saved routes
        </h1>
        <p className="mt-4 text-[#5C665F]">
          The routes you have bookmarked for future adventures.
        </p>

        <div
          className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6"
          data-testid="favorites-grid"
        >
          {routes.map((r) => (
            <RouteCard key={r.id} route={r} />
          ))}
        </div>

        <Pagination
          page={page}
          pageSize={pageSize}
          total={total}
          onPageChange={setPage}
        />

        {loaded && routes.length === 0 && (
          <div className="text-center text-[#5C665F] py-20">
            No favourites yet. Tap the heart on any route to save it.
          </div>
        )}
      </div>
    </div>
  );
}
